import { useState, useCallback } from 'react';

export const useFilterSet = (initialState = {}) => {
  const [filters, setFilters] = useState(initialState);

  const updateFilter = useCallback((questionText, optionText) => {
    setFilters(prev => {
      if (prev[questionText] === optionText) {
        const newFilters = { ...prev };
        delete newFilters[questionText];
        return newFilters;
      }
      
      if (Object.keys(prev).length < 4 || prev[questionText]) {
        return { ...prev, [questionText]: optionText };
      }
      
      return prev;
    });
  }, []);

  const resetFilters = useCallback(() => {
    setFilters({});
  }, []);

  return { filters, updateFilter, resetFilters };
};